export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10484.cae64da1.jpg";